import VideojsTracker from './tracker';
export default VideojsTracker;